import { HorizontalDivider, Icon, Typography } from '@smartgift/frontend-toolkit';
import { Fragment } from 'react';

import * as S from './style';

function ReviewAndSubmit({ desc, icon, table }) {
  return (
    <S.ReviewAndConfirm>
      <Typography variant="body2" color="neutral" emphasis="500">
        {desc}
      </Typography>
      <S.ReviewBoxWrapper>
        <Icon name={icon} style={{ minWidth: 80, width: 80, height: 80, minHeight: 80 }} />
        <S.ReviewBox>
          {table.map((row, index) => {
            return (
              <Fragment key={row.key}>
                {row.type === 'accordion' ? (
                  <S.ReviewAccordion title={row.key} endContent={row.value} variant="contained">
                    {row.table.map(row2 => {
                      return (
                        <S.Row key={row2.key}>
                          <Typography variant="body2SemiBold">
                            {row2.key}
                            <Typography variant="caption1" color="neutral" emphasis="400">
                              {row2.helpText}
                            </Typography>
                          </Typography>
                          <S.Value>{row2.value}</S.Value>
                        </S.Row>
                      );
                    })}
                  </S.ReviewAccordion>
                ) : (
                  <S.ReviewBoxRow isActive={row.isActive}>
                    <Typography variant={row.isActive ? 'body1Bold' : 'body2'}>
                      {row.key}:
                    </Typography>
                    <Typography variant={row.isActive ? 'body1Bold' : 'body2'}>
                      {row.value}
                    </Typography>
                  </S.ReviewBoxRow>
                )}

                {index !== table.length - 1 && !row.isActive && (
                  <HorizontalDivider $margin="8px 0" />
                )}
              </Fragment>
            );
          })}
        </S.ReviewBox>
      </S.ReviewBoxWrapper>
    </S.ReviewAndConfirm>
  );
}

export { ReviewAndSubmit };
